var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.feather_een{fill:#0B1719;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "feather_een",
    d: "M13.219,15.087l-0.049-0.024C13.681,14.524,14,13.801,14,13c0-1.657-1.343-3-3-3s-3,1.343-3,3 c0,0.801,0.319,1.524,0.83,2.062l-0.049,0.024C7.668,15.829,7,17.078,7,18.415V21c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-2.585 C15,17.078,14.332,15.829,13.219,15.087z M11,11c1.103,0,2,0.897,2,2c0,1.103-0.897,2-2,2s-2-0.897-2-2C9,11.897,9.897,11,11,11z  M14,21H8v-2.585c0-0.986,0.48-1.903,1.288-2.464l0.463-0.231C10.132,15.896,10.553,16,11,16s0.868-0.104,1.249-0.28l0.463,0.231 C13.52,16.512,14,17.429,14,18.415V21z M28,5H4C2.343,5,1,6.343,1,8v16c0,1.657,1.343,3,3,3h24c1.657,0,3-1.343,3-3V8 C31,6.343,29.657,5,28,5z M30,24c0,1.103-0.897,2-2,2H4c-1.103,0-2-0.897-2-2V8c0-1.103,0.897-2,2-2h24c1.103,0,2,0.897,2,2V24z  M25,16.5c0,0.276-0.224,0.5-0.5,0.5h-6c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6C24.776,16,25,16.224,25,16.5z M25,18.5 c0,0.276-0.224,0.5-0.5,0.5h-6c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6C24.776,18,25,18.224,25,18.5z M25,14.5 c0,0.276-0.224,0.5-0.5,0.5h-6c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h6C24.776,14,25,14.224,25,14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentify);
export default __webpack_public_path__ + "static/media/identify.b6531d7371db5c95355c3d07185d31eb.svg";
export { ForwardRef as ReactComponent };